<template>
    <div
        v-if="isBulkActionLoading"
        class="popup"
    >
        <div class="wrap">
            <LoaderAnimation />
        </div>
    </div>
</template>

<script>
import TaskModule from "@/store/modules/task";
import LoaderAnimation from "@/components/Animation/LoaderAnimation";

export default {
    name: "LoaderPopup",
    components: {
        LoaderAnimation
    },
    setup(props, { emit }) {
        const { isBulkActionLoading } = TaskModule();

        return {
            isBulkActionLoading
        };
    }
};
</script>

<style scoped lang="scss">
.popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(193, 193, 193, 0.5);
    z-index: 5;
    overflow-y: auto;

    .wrap {
        max-width: 150px;
    }
}
</style>
